"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NProgress = require("nprogress");
exports.PageLoadingIndicator = NProgress;



//////////////////
// WEBPACK FOOTER
// ./src/components/PageLoadingIndicator.tsx
// module id = 365
// module chunks = 0